
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seo-pricing-uk",
      function () {
        return require("private-next-pages/seo-pricing-uk/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seo-pricing-uk"])
      });
    }
  